// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/deductions",
  ListShort: "/pyr/deductions/short",
  Create: "/pyr/deductions",
  Update: "/pyr/deductions",
};
